import React from "react";
import styled from "styled-components";
import { Button } from "../../..";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { Modal } from "react-bootstrap";
import { EmailPreviewModalProps } from "../types";
import { FiledEmailType } from "../../../../types/EmailType";
import { FiledEmailDisplayCard } from "./FiledEmailDisplayCard";
import ThemedModal from "../../../utilities/ThemedModal";

const DialogBody = styled(Modal.Body)`
    min-height: 66.67vh;
    max-height: 66.67vh;
    display: flex;
    flex-direction: column;
`;

export const EmailPreviewModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    data,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "xl",
    ...rest
} : Readonly<EmailPreviewModalProps>) => {
    const [bodyAnimation] = useAutoAnimate();
    const [email, setEmail] = React.useState<FiledEmailType>(data);

    const onClose = () => cancel!();

    return (
        <Modal className="overflow-visible" backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header closeButton>
                <Modal.Title>{email.subject && email.subject.length > 0 ? email.subject : '(No subject)'}</Modal.Title>
            </ThemedModal.Header>
            <DialogBody ref={bodyAnimation}>
                <FiledEmailDisplayCard data={email} />
            </DialogBody>
            <Modal.Footer>
                <Button variant="light" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};